function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8091"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7907"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 25",
  d: "M70 140A70 70 0 100 70a70 70 0 0070 70",
  fill: "#e8f6f4"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2295",
  d: "M100.912 70.451L61.664 109.7 36.677 84.709l10.732-10.732 14.255 14.254L90.18 59.719zM90.18 30.298L61.664 58.814 47.406 44.556 36.674 55.289l24.99 24.99 39.248-39.248z",
  fill: "#a1dbd3"
}));
var SvgCheckmarks = function SvgCheckmarks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 140"
  }, props), _ref);
};
export default SvgCheckmarks;